module.exports = __webpack_public_path__ + "img/cashback_1632.299669f1.png";